import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useDispatch } from 'react-redux';
import ModalFileImport from '../ModalFileImport';
import ModalFileLoading from '../ModalFileLoading';
import { WarningToast } from '../../molecules/Toast';

import { Creators as DocumentoActions } from '../../../store/ducks/documento';

import orientacoesDocumentos from '../../../assets/modelos/orientacoes_documentos.txt';

const ImportarDocumentos = ({
  isOpen,
  idLista,
  onCloseModal,
  documentosImportacao,
}) => {
  const dispatch = useDispatch();

  const [files, setFiles] = useState([]);

  const maxSizeFiles = 5242880;
  const maxQuantityFiles = 100000000000000000;
  const validExtension = ['jpg', 'jpeg', 'pdf', 'png', 'tiff'];

  const getErrors = ({ fileErrors, hasMaxQuantity }) => {
    if (hasMaxQuantity) {
      toast.error(
        <WarningToast>
          Somente podem ser enviados {maxQuantityFiles} arquivos por lote.
        </WarningToast>
      );
    }

    if (fileErrors.length > 0) {
      fileErrors.forEach((error) => {
        if (error.error.hasMaxSize) {
          toast.error(
            <WarningToast>
              O arquivo <strong>{error.name}</strong> é maior que o tamanho
              permitido.
            </WarningToast>
          );
        }
        if (error.error.hasValidExtension) {
          toast.error(
            <WarningToast>
              O arquivo <strong>{error.name}</strong> não possui extensão
              válida.
            </WarningToast>
          );
        }
      });
    }
  };

  useEffect(() => {
    if (files && files.length > 0) {
      dispatch(
        DocumentoActions.postDocumentosImportacaoRequest(files, idLista)
      );
    }
  }, [dispatch, files, idLista]);

  return (
    <>
      <ModalFileImport
        isOpen={isOpen}
        onClick={onCloseModal}
        contentText={
          <>
            Realize o envio dos
            <strong> documentos dos beneficiarios </strong>
            através de arquivos com extensão
            <strong> (jpg, jpeg, pdf, png e tiff)</strong>.
          </>
        }
        contentModeloPadrao={
          <>
            Para te auxiliar, temos um
            <a
              href={orientacoesDocumentos}
              download="orientacoes_documentos.txt"
            >
              {' '}
              documento com as orientações{' '}
            </a>
            demonstrando como os arquivos devem ser enviados.
          </>
        }
        setListaFiles={(newFiles) => setFiles(newFiles)}
        applyValidation
        maxQuantityFiles={maxQuantityFiles}
        maxSizeFiles={maxSizeFiles}
        validExtension={validExtension}
        invalidCallback={(errors) => getErrors(errors)}
      />
      <ModalFileLoading
        isOpen={
          (documentosImportacao.loading ||
            documentosImportacao.success ||
            documentosImportacao.error) &&
          isOpen
        }
        files={documentosImportacao.files}
        finishedLoadingFiles={onCloseModal}
        isSuccess={documentosImportacao.success}
        onClickCancel={onCloseModal}
      />
    </>
  );
};

export default ImportarDocumentos;
